module.exports = __webpack_public_path__ + "img/Connect_App@2x.c16b5448.png";